// extracted by mini-css-extract-plugin
module.exports = {"alert":"AddToHome_alert__j3wcp","info":"AddToHome_info__QbzLR"};